import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el YOGA RESUELTA después de comprar?',
  a: 'Inmediatamente después del pago recibís un email con el enlace de descarga de todos los PDFs. Acceso en menos de 5 minutos desde cualquier dispositivo.'
}, {
  q: '¿Sirve para profes con poca experiencia o solo para los avanzados?',
  a: 'Sirve para ambos. El sistema está diseñado desde cero para que una profe recién egresada pueda empezar a dar clases profesionales desde el primer día, y para que una profe con años de experiencia optimice su sistema y deje de improvisar.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'Los PDFs están listos para usar tal cual. Podés leerlos, proyectarlos o imprimirlos. Si necesitás editar alguna sección podés hacerlo con Adobe Acrobat u otras herramientas.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos están incluidos en ambas ofertas sin costo adicional. La diferencia entre las dos ofertas es el Yoga Terapéutico Pro™ que viene solo en el Pack Completo.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Sirve para ambos. Cada tomo incluye adaptaciones para clases individuales y grupales, presenciales y online.'
}, {
  q: '¿Sirve si tengo alumnos de distintos niveles al mismo tiempo?',
  a: 'Sí. El sistema de variaciones en 3 niveles por postura está diseñado específicamente para grupos heterogéneos. Mostrás las 3 versiones y cada alumno elige la suya.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de Yoga?',
  a: 'Yoga Resuelta es el único sistema en Argentina que combina clases listas, posturas detalladas, progresión anual, poblaciones especiales, meditaciones guiadas y sistema de negocio en un solo producto estructurado para instructoras.'
}, {
  q: '¿Por qué elegir el Pack Completo y no el estándar?',
  a: 'Si tenés o querés tener alumnos con condiciones especiales (embarazo, lesiones, adultos mayores, estrés severo), el Yoga Terapéutico Pro™ te da los protocolos exactos para trabajar con seguridad y diferenciarte como la profe de referencia en tu zona.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días con devolución del 100% sin preguntas. Escribís a contacto@recursosfitness.shop y listo.'
}];
export function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);
  const toggleAccordion = (id: number) => {
    setOpenId(openId === id ? null : id);
  };
  return <section className="py-12 md:py-24 bg-white" data-id="element-103">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-104">
        <div className="text-center mb-8 md:mb-16" data-id="element-105">
          <div className="inline-flex items-center justify-center p-2 md:p-3 bg-yoga-purple-50 rounded-full mb-3 md:mb-4" data-id="element-106">
            <HelpCircle className="w-6 h-6 md:w-8 md:h-8 text-yoga-purple-600" data-id="element-107" />
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-gray-900" data-id="element-108">
            PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-109">
          {faqs.map((faq, index) => {
          const isOpen = openId === index;
          return <div key={index} className="border border-gray-200 rounded-lg md:rounded-xl overflow-hidden bg-white" data-id="element-110">
                <button onClick={() => toggleAccordion(index)} className="w-full flex items-center justify-between p-4 md:p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-111">
                  <span className="font-bold text-gray-900 pr-6 md:pr-8 text-sm md:text-base" data-id="element-112">
                    {faq.q}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-113">
                    <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 ${isOpen ? 'text-yoga-purple-600' : 'text-gray-400'}`} data-id="element-114" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-115">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-116">
                      <div className="p-4 md:p-6 pt-0 text-gray-600 leading-relaxed border-t border-gray-100 mt-1 md:mt-2 text-sm md:text-base" data-id="element-117">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}